import { StorefrontCart } from "src/types/storefront"

export const bulkDiscountActiveContextKey = "bulk_discount_active"

export const bulkDiscountBarSteps = [
  { count: 1, percent: 0 },
  { count: 2, percent: 5 },
  { count: 3, percent: 10 },
  { count: 4, percent: 15 },
] as const satisfies {
  count: number
  percent: number
}[]

export function countBulkDiscountableItems(cart: StorefrontCart | null): number {
  return (cart?.items || [])
    .filter((item) => item.product.flags.discountable)
    .reduce((sum, item) => sum + item.quantity, 0)
}
